<template>
  <div>
    <v-sheet id="sub-cat-nav">
      <v-slide-group
        show-arrows
        v-model="model"
        mandatory
        justify="start"
        class="slide-group"
      >
        <v-slide-item
          v-for="(item, index, btnIndex) in subitem"
          :key="index"
          class="slide-item"
          v-slot:default="{ active }"
        >
          <v-col class="py-0 px-2 text-center flex-grow-0">
            <v-btn
              class="display-22 px-6 mx-1"
              :class="`btn-slide${btnIndex}`"
              @click.prevent="
                [
                  !active
                    ? getJobsBySubcat(
                        item.Code,
                        companyCode,
                        companyDisplayUrl,
                        btnIndex,
                        item.Code,
                        item.NumberOfJobs
                      )
                    : null,
                ]
              "
              :large="!isMobile"
              :small="isMobile"
              rounded
              text
              outlined
              active-class="primary white--text"
              :disabled="isLoading"
              :input-value="active"
            >
              <span>
                {{ item.Code === 3.14 ? 'כל המשרות' : item.NameInHebrew }}
              </span>
            </v-btn>

            <p v-if="isLoading" class="jobs-number display-16 mt-2 mb-0">
              {{ item.Code === 3.14 ? jobsInCompany : item.NumberOfJobs }} משרות
              פתוחות
            </p>
          </v-col>
        </v-slide-item>
      </v-slide-group>
      <v-row>
        <v-col class="mr-3">
          <h5 v-if="!isLoading">{{ numJobsToDisplay }} משרות פתוחות</h5>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import drushim_lodash from 'lodash';
export default {
  data() {
    return {
      model: drushim_lodash.size(this.subcats),
      numJobsToDisplay: null,
      /**
       * Temp Object will be merge with data reulstd
       * @Code will display as all categories button
       */
      obj: {
        999: {
          Code: 3.14,
        },
      },
    };
  },
  props: {
    subcats: {
      type: Object,
    },
    companyName: {
      type: String,
    },
    companyDisplayUrl: {
      type: String,
    },
    companyCode: {
      type: String,
    },
    isLoading: {
      type: Boolean,
    },
    isMobile: {
      type: Boolean,
    },
    jobsBySubcategoryNum: {
      type: Number,
    },
    jobsInCompany: {
      type: Number,
    },
  },
  mounted() {
    this.numJobsToDisplay = this.jobsInCompany;
  },
  computed: {
    subitem() {
      return drushim_lodash.merge(this.obj, this.subcats);
    },
  },

  methods: {
    getAllJobs() {
      this.$emit('displayAllJobs');
    },
    getJobsBySubcat(
      catdir,
      companycode,
      companyDisplayUrl,
      i,
      itemCode,
      numJobs
    ) {
      this.model = i;

      if (itemCode === 3.14) {
        this.numJobsToDisplay = this.jobsInCompany;
        this.$emit('displayAllJobs');
      } else {
        this.numJobsToDisplay = numJobs;
        this.$emit('displayJobsFor', catdir, companycode, companyDisplayUrl);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#sub-cat-nav .theme--light.v-btn {
  color: $primary;
}
.jobs-number {
  margin: 0 auto;
  text-align: center;
}
#sub-cat-nav .v-slide-group__content {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
#sub-cat-nav .v-slide-group.v-item-group .v-icon.v-icon {
  font-size: 40px;
  margin-top: -30px;
  color: $primary;
}

@media only screen and (min-width: 600px) {
  #sub-cat-nav .v-slide-group.v-item-group .v-icon.v-icon {
    font-size: 70px;
    margin-top: -30px;
    color: $primary;
  }
  .slide-item .v-icon.v-icon {
    font-size: 70px;
  }
}
</style>
